var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.row.bcr_request_balance))])])}
var staticRenderFns = []

export { render, staticRenderFns }